import { render, staticRenderFns } from "./ImageRotationModal.vue?vue&type=template&id=1c5cb36b&scoped=true"
import script from "./ImageRotationModal.vue?vue&type=script&lang=js"
export * from "./ImageRotationModal.vue?vue&type=script&lang=js"
import style0 from "./ImageRotationModal.vue?vue&type=style&index=0&id=1c5cb36b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5cb36b",
  null
  
)

export default component.exports